<template>
  <div class="cart-box " v-back-to-top="'4rem'" :class="{ 'min-height-100 ': type == 2 }"
    :style="list.length > 0 || nonActiveList.length > 0 ? 'background: transparent;' : 'background: #fff;'">
    <van-nav-bar>
      <template #left>
        <div style="display: flex;align-items: center;">
          <i class="icon-back" @click="$router.back()" v-if="type == 2"></i>
          <span class="title">采购车<i v-if="$store.state.cartNum">({{ $store.state.cartNum > 99 ? '99+' :
            $store.state.cartNum
              }})</i></span>
        </div>
      </template>
      <template #right v-if="$fn.isLogin() && list.length > 0">
        <span class="title-del" @click="delSelect">删除</span>
      </template>
    </van-nav-bar>
    <!-- 空页面加载 -->
    <van-loading v-if="loading" type="spinner" color="#111111" />
    <!-- 未登陆 -->
    <van-empty v-else-if="!$fn.isLogin()" class="custom-image" image="https://xhdata.wan4.com/wsw-h5-9.png"
      description="请登录后查看">
      <van-button class="on-btn" type="primary" to="/login">登录</van-button>
    </van-empty>
    <!-- 无数据 -->
    <van-empty v-else-if="list.length == 0" class="custom-image" image="https://xhdata.wan4.com/wsw-h5-20.png"
      description="采购车空空如也，先去逛逛吧～">
      <van-button class="on-btn" type="primary" replace to="/">逛首页</van-button>
    </van-empty>
    <!-- 购物车列表 -->
    <template v-else>
      <div class="list-box">
        <div class="item-box" v-for="item, index in list" :key="index">
          <div class="company-title-box">
            <i class="select" :class="{ 'select-on': isGoodsOpt(item.goodsList) }"
              @click="setGoodsOpt(item.goodsList, !isGoodsOpt(item.goodsList))"></i>
            <span @click="$router.push(`/goods/shop?type=3&memCode=${item.memCode}`)">工厂{{ item.memCode }}</span>
          </div>
          <div class="goods-item" v-for="goods, gIndex in item.goodsList" :key="gIndex">
            <div class="sku-item" :class="{
              'sku-item-active': sku.opt,
              'sku-item-no-buttom-line': sku.opt && skuIndex < (goods.skuList.length - 1) && goods.skuList[skuIndex + 1].opt,
              'sku-item-no-top-line': sku.opt && skuIndex > 0 && goods.skuList[skuIndex - 1].opt
            }" v-for="sku, skuIndex in goods.skuList" :key="skuIndex">
              <i class="select sku-select" :class="{ 'select-on': sku.opt }" @click="optSku(sku)"></i>
              <div class="pic">
                <img v-lazy="sku.skuImgUrl + '?imageView2/1/w/120/h/120'" :key="sku.skuImgUrl"
                  @click="showImagePreview([sku.skuImgUrl], 0)" />
              </div>
              <span class="goods-title overflow" @click="toGoodsDeltal(goods, sku)">{{ goods.goodsName }}</span>
              <span class="goods-code" @click="toGoodsDeltal(goods, sku)">【商品编号：{{ goods.goodsCode }}】</span>
              <span class="sku-info" @click="toGoodsDeltal(goods, sku)">{{ getSkuStr(sku) }}</span>
              <span class="kc-info"><i>【{{ sku.minNum }}{{ sku.goodsUnit }}起订】，</i>库存 {{ Number(sku.sttl ||
                0).toLocaleString() }}</span>
              <div class="price-box">
                <span class="price">{{ $fn.initPrice(sku.price, 0) }}<i>{{ $fn.initPrice(sku.price, 1)
                    }}</i><i>元/{{ sku.goodsUnit }}</i></span>
                <Stepper v-model="sku.buyQty" :min="0" :disable-minus="sku.buyQty <= sku.minNum" :max="sku.maxNum"
                  :disable-input="sku.maxNum < sku.minNum" integer @overlimit="checkBuyQty(sku)" @plus="onPlus(sku)"
                  @blur="onPlus(sku)" @change="upBuyQty(sku)">
                </Stepper>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="bottom-box" :class="{'bottom-box2' : type == 2}" >
        <i class="select" :class="{ 'select-on': isAllOpt }" @click="isAllOpt = !isAllOpt"></i>
        <span @click="isAllOpt = !isAllOpt">全选</span>
        <div>
          <span class="count-box">数量总计：<i>{{ countTtl.toLocaleString() }}</i></span>
          <span class="price-box">金额总计：<i>{{ $fn.initPrice(priceTtl, 0) }}</i><i>{{ $fn.initPrice(priceTtl, 1)
              }}元</i></span>
          <span class="hint-box">(不含运费)</span>
        </div>
        <van-button :disabled="countTtl == 0" type="primary" @click="buy">结算</van-button>
      </div>

    </template>

    <!-- 失效商品 -->
    <template v-if="nonActiveList && nonActiveList.length > 0">
      <div class="no-activie-title-box" :class="{ 'mt-20': list.length > 0 }">
        <span>失效商品</span>
        <i @click="delAllNoActive()">清空失效商品</i>
      </div>
      <div class="list-box no-active-list-box">
        <div class="goods-item" v-for="goods, gIndex in nonActiveList" :key="gIndex">
          <div class="sku-item" v-for="sku, skuIndex in goods.skuList" :key="skuIndex">
            <i class="select sku-select select-disabled"></i>
            <div class="pic">
              <img v-lazy="sku.skuImgUrl + '?imageView2/1/w/120/h/120'" :key="sku.skuImgUrl" />
              <span>失效商品</span>
            </div>
            <span class="goods-title overflow" style="color: #BBB;">{{ goods.goodsName }}</span>
            <span class="goods-code" style="color: #BBB;">【商品编号：{{ goods.goodsCode }}】</span>
            <span class="sku-info" style="color: #BBB;background: #FDFDFD;">{{ getSkuStr(sku) }}</span>
            <span class="sku-del" @click="delNoActive(sku)">删除</span>
          </div>
        </div>
      </div>
    </template>


    <maxPriceDialog v-model="showTs"></maxPriceDialog>
    <maxPayCountDialog v-model="showTs2"></maxPayCountDialog>
  </div>
</template>
<script>

import { Stepper, ImagePreview } from 'vant';
import maxPriceDialog from '../../components/maxPriceDialog.vue';
import maxPayCountDialog from '../../components/maxPayCountDialog.vue';
export default {
  name: 'Cart',
  components: {
    Stepper, maxPriceDialog, maxPayCountDialog
  },
  data() {
    return {
      type: 1,//首页 2其它页面进来，隐藏底部
      loading: false,
      list: [],
      nonActiveList: [],
      upBuyQtyTimeoutId: '',
      showTs: false,
      showTs2: false,
    }
  },
  computed: {
    isAllOpt: {
      get() {
        let e = true;
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              if (!sku.opt) {
                e = false;
              }
            })
          })
        })
        return e
      },
      set(vl) {
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              this.$set(sku, 'opt', vl)
            })
          })
        })
      }
    },
    //数量总数
    countTtl: {
      get() {
        let count = 0;
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              if (sku.opt) {
                count += Number(sku.buyQty || 0);
              }
            })
          })
        })
        return count;
      }
    },
    //金额总数
    priceTtl: {
      get() {
        let pric = 0;
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              if (sku.opt) {
                pric += Number(sku.subTtlAmt || 0);
              }
            })
          })
        })
        return pric;
      }
    }
  },
  created() {
    this.type = this.$route.query.type || 1;
    if (this.$fn.isLogin()) {
      this.loading = true;
      this.getData();
    }
    if (this.type == 2) {
      this.$nextTick(() => {
        document.getElementById('homeTabbar').style.display = 'none';
      })
    }
  },
  methods: {
    //查看大图
    showImagePreview(imgs, index) {
      ImagePreview({
        images: imgs,
        startPosition: index
      })
    },
    getData() {
      // this.$ajax('/iap-api/wan4/presonal/cart/myCartCount.do', {}).then(res => {
      //   this.catCount = res.data.catCount == 0 ? '' : res.data.catCount
      // })
      this.$ajax('/iap-api/wan4/presonal/cart/myCart.do', {}).then(res => {
        this.loading = false;
        this.list = res.data.rows || [];
        this.nonActiveList = res.data.nonActiveRows || [];
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              sku.maxNum = this.maxNum(sku.sttl);
              sku.minNum = this.minNum(sku.priceInfo);
            })
          })
        })
      })
    },
    //最小起订量
    minNum: function (arr) {
      let num = ''
      if (arr.length == 0) {
        num = ''
      }
      else {
        num = arr[arr.length - 1].fm
      }
      return num
    },
    //最大购买数量
    maxNum(sttl) {
      if (sttl > 99999) {
        return 99999;
      }
      return sttl;
    },
    optSku(item) {
      this.$set(item, 'opt', !item.opt);
    },
    //商品的sku是否全部选中
    isGoodsOpt(list) {
      let e = true;
      list.forEach(goods => {
        goods.skuList.forEach(sku => {
          if (!sku.opt) {
            e = false;
          }
        })
      })
      return e;
    },
    //设置商品中的sku选中状态
    setGoodsOpt(list, vl) {
      list.forEach(goods => {
        goods.skuList.forEach(sku => {
          this.$set(sku, 'opt', vl)
        })
      })
    },
    //删除选中商品
    delSelect() {
      if (this.countTtl == 0) {
        this.$toastUtil.show('请至少选择一个商品')
        return
      }
      this.$dialog.confirm({
        message: `确定 <span style='font-weight: bold;'>删除已选商品</span> 吗?`
      }).then(() => {
        let arr = [];
        this.list.forEach(item => {
          item.goodsList.forEach(goods => {
            goods.skuList.forEach(sku => {
              if (sku.opt) {
                arr.push(sku.cartId)
              }
            })
          })
        })
        this.del(arr.join(','))
      }).catch(() => {
      });
    },
    //清空失效商品
    delAllNoActive() {
      this.$dialog.confirm({
        message: `确定 <span style='font-weight: bold;'>清空失效商品</span> 吗?`
      }).then(() => {
        let arr = [];
        this.nonActiveList.forEach(goods => {
          goods.skuList.forEach(sku => {
            arr.push(sku.cartId)
          })
        })
        this.del(arr.join(','))
      }).catch(() => {
      });
    },
    //删除失效商品
    delNoActive(sku) {
      this.$dialog.confirm({
        message: `确定 <span style='font-weight: bold;'>删除失效商品</span> 吗?`
      }).then(() => {
        this.del(sku.cartId)
      }).catch(() => {
      });
    },
    //删除
    del(cartId) {
      this.$ajax('/iap-api/wan4/presonal/cart/cartRemoveGoods.do', { cartId }).then(() => {
        this.getData();
      })
    },
    getSkuStr(sku) {
      let arr = [];
      if (sku.colorText) {
        arr.push(sku.colorText)
      }

      if (sku.czText) {
        arr.push(sku.czText)
      }
      if (sku.sizeText) {
        if (sku.sizeText.indexOf("-∅") >= 0) {
          arr.push(sku.sizeText.slice(0, sku.sizeText.indexOf("-∅")))
        } else {
          arr.push(sku.sizeText)
        }
      }
      if (arr.length > 0) {
        return arr.join('；')
      }
      return '-';
    },
    //校验购买数量
    checkBuyQty(item) {
      if (item.minNum > item.maxNum) {
        this.$toastUtil.show('库存不足，无法满足起订量')
      } else if (item.minNum >= item.buyQty) {
        this.$toastUtil.show('最小采购数量为' + Number(item.buyQty).toLocaleString())
      } else if (item.maxNum <= item.buyQty) {
        this.$toastUtil.show('已达最大可选数量')
      }
    },
    onPlus(item) {
      if (item.minNum >= item.buyQty) {
        this.$set(item, 'buyQty', item.minNum)
      }
    },
    upBuyQty(item) {
      this.$nextTick(() => {
        let buyQty = item.buyQty;
        if (item.maxNum < buyQty) {
          buyQty = item.maxNum;
          item.buyQty = buyQty;
          this.$toastUtil.show('已达最大可选数量')
        } else if (item.minNum >= item.buyQty) {
          buyQty = item.minNum;
        }
        if (this.upBuyQtyTimeoutId) {
          clearTimeout(this.upBuyQtyTimeoutId);
        }
        this.upBuyQtyTimeoutId = setTimeout(() => {
          this.$ajax('/iap-api/wan4/presonal/cart/cartEditQty.do', { cartId: item.cartId, buyQty })
        }, 500);

        item.priceInfo.forEach(price => {
          if (item.buyQty >= price.fm && item.buyQty <= price.to) {
            item.price = price.vl;
          }
        })
        item.subTtlAmt = item.price * item.buyQty;
      })
    },
    toGoodsDeltal(goods, sku) {
      this.$router.push(`/goods/details?oid=${goods.oid}&odid=${goods.oid}_${sku.skuSeq}`)
    },
    //购买
    async buy() {
      let cartList = [];
      this.list.forEach(item => {
        item.goodsList.forEach(goods => {
          goods.skuList.forEach(sku => {
            if (sku.opt) {
              cartList.push({
                cartId: sku.cartId,
                buyQty: sku.buyQty
              })
            }
          })
        })
      })
      //单笔金额超过5w
      if ((this.priceTtl / 100) >= 50000) {
        this.showTs = true;
        return
      }

      let res3 = await this.$ajax('/iap-api/wan4/order/buyerGetTlPaymentCount.do', {});
      if (res3.data >= 20) {
        this.showTs2 = true
        return
      }

      this.$ajax('/iap-api/wan4/presonal/cart/orderPreviewPageData4Cart.do', { cartList, req: true }).then(res => {
        if (res.meta.res == '00000') {
          this.$ajax('/iap-api/wan4/base/setSelfDefinedDataCache.do', { tempId: '', myData: { res: res.data, req: { cartList } } }).then(res2 => {
            this.$router.push('/order/buy?cacheId=' + res2.data);
          })
        } else {
          this.$dialog
            .alert({
              message: res.meta.msg.indexOf('库存数量不够') >= 0 ? '购买数量超过库存' : (res.meta.msg.indexOf('购买数量不能小于起批数') >= 0 ? '购买数量不能小于起批数' : res.meta.msg),
            })
            .then(() => { });
        }

      })
    }

  },
}
</script>
<style lang="less" scoped>

.cart-box {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: calc(130px + env(safe-area-inset-bottom) + 96px);
  padding-top: 88px;
  min-height: 100vh;
  overflow-y: scroll;


  .title {
    color: #333;
    font-size: 38px;
    font-style: normal;
    font-weight: bold;
    display: flex;

    >i {
      font-size: 28px;
      margin-left: 5px;
    }
  }

  .title-del {
    color: #F53F3F;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
  }


  .list-box {
    display: flex;
    flex-direction: column;
    flex: 1;

    >* {
      flex-shrink: 0;
    }

    .item-box {
      margin: 10px 0;
      background: #fff;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      padding-bottom: 32px;

      &:last-child {
        margin-bottom: 0;
      }

      .company-title-box {
        height: 76px;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        align-items: center;
        padding-left: 12px;

        >span {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          display: flex;
          align-items: center;

          &::after {
            content: '';
            width: 28px;
            height: 28px;
            background: url('https://xhdata.wan4.com/wsw-h5-12.png') no-repeat center;
            background-size: 100%;
            margin-left: 2px;
          }
        }
      }


    }
  }

  .mt-20 {
    margin-top: 20px;
  }

  .no-activie-title-box {
    display: flex;
    height: 76px;
    background: #FFF;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
    padding: 0 24px;
    flex-shrink: 0;

    >span {
      color: #333;
      font-size: 28px;
      font-style: normal;
      font-weight: 600;
      margin-right: auto;
    }

    >i {
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
    }
  }

  .no-active-list-box {
    background: #fff;

    .goods-item {
      margin-top: 32px;
      margin-bottom: 32px;
      position: relative;

      &:first-child {
        margin-top: 20px;

        &::after {
          content: none;
        }
      }

      &::after {
        position: absolute;
        top: -32px;
        left: -24px;
        right: -24px;
        content: '';
        background: #E5E5E5;
        height: 1px;
      }
    }
  }

  .bottom-box {
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 24px;
    height: 130px;
    border-top: 1px solid #E5E6EB;
    background: #FFF;
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom) + 96px);
    left: 0;
    right: 0;
    z-index: 100;

    >span {
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
    }

    >div {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin: 0 24px;

      .count-box {
        color: #999;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;

        >i {
          color: #333;
          font-weight: bold;
        }
      }

      .price-box {
        color: #999;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 44px;

        >i {
          color: #F53F3F;
          font-size: 32px;
          font-weight: bold;
        }

        >i+i {
          font-size: 24px;
        }
      }

      .hint-box {
        color: #999;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
      }
    }

    .van-button {
      width: 220px;
      height: 86px;
      font-size: 28px;
      font-style: normal;
      font-weight: bold;
      border-radius: 12px;
    }

    .van-button--disabled {
      background: #C9CDD4;
      border-color: #C9CDD4;
      opacity: 1;
    }
  }

  .bottom-box2{
    bottom: 0;
    height: calc(env(safe-area-inset-bottom) + 130px);
    padding-bottom: calc(env(safe-area-inset-bottom));
  }


}
.min-height-100 {
  padding-bottom: calc(130px + env(safe-area-inset-bottom));
}

.select {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;

  &::after {
    content: '';
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 2px solid #999;
    background: #FFF;
  }

  &-on {
    &::after {
      width: 32px;
      height: 32px;
      border-width: 0px;
      background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
      background-size: 100% 100%;
    }
  }

  &-disabled {
    &::after {
      border: 2px solid #D8D8D8;
      background: #EEE;
    }
  }


}


.goods-item {
  background: #F4F4F4;
  display: flex;
  flex-direction: column;
  margin: 24px 24px 0;
  border-radius: 4px;

  .sku-item {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid #F4F4F4;
    padding: 32px 24px 32px 206px;
    position: relative;

    &-active {
      background: #FFF7E8;
      border: 1px solid #FF6634;
      z-index: 1;

      &::after {
        content: none !important;
      }
    }

    &-no-buttom-line {
      border-bottom: 1px solid transparent !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    &-no-top-line {
      border-top: 1px solid #FFF7E8 !important;
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;

      //补充border-bottom 和 border-top 的空隙
      &::before{
        content: '';
        position: absolute;
        top: -3px;
        left: -1px;
        right: -1px;
        height: 5px;
        border-left: 1px solid #FF6634;
        border-right: 1px solid #FF6634;
      }

      &::after {
        content: '' !important;
        background: #FF6634 !important;
      }
    }

    &::after {
      content: '';
      position: absolute;
      height: 1px;
      left: 24px;
      right: 24px;
      top: -3px;
      background: #DCDCDC;
    }

    &:first-child {
      padding-top: 24px;

      &::after {
        content: none;
      }
    }

    &-active {
      border: 1px solid #FF6634;
      background: #FFF7E8;
    }

    .sku-select {
      position: absolute;
      top: 57px;
      left: 12px;
    }

    .pic {
      position: absolute;
      border-radius: 4px;
      border: 2px solid #DCDCDC;
      width: 120px;
      height: 120px;
      top: 24px;
      left: 70px;
      overflow: hidden;

      >img {
        width: 100%;
        height: 100%;
      }

      >span {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 38px;
        border-radius: 0px 0px 4px 4px;
        background: #00000099;
        color: #FFF;
        font-size: 24px;
        text-align: center;
        line-height: 38px;
      }
    }

    .goods-title {
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 34px;
    }

    .goods-code {
      color: #666;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 6px;
    }

    .sku-info {
      border-radius: 2px;
      background: #FFF;
      padding: 12px 18px;
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 12px;
      word-break: break-all;
    }

    .sku-del {
      margin-top: 8px;
      margin-left: auto;
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
    }

    .kc-info {
      color: #666;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px;
      margin-top: 12px;

      >i {
        color: #FF6634;
      }
    }

    .price-box {
      display: flex;
      margin: 14px 0 0;
      align-items: center;

      .price {
        color: #F53F3F;
        font-family: Arial;
        font-size: 34px;
        font-weight: bold;
        line-height: 34px;
        margin-right: auto;

        >i {
          font-size: 24px;
        }

        >i+i {
          font-weight: 600;
        }
      }
    }
  }

}
</style>